<section *ngIf="saldosMedicos" class="card">
    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">                       
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success" (click)="exportExcel()"></button>
        </ng-template>    
      
    </p-toolbar>
    <p-table [value]="paginacionSaldosMedicos" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Medico</th>
                <th>Puntos</th>
                <th>Redimir</th>
                <th>Saldo</th>             
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-medico>
            <tr>                
                <td> <a [routerLink]="['/administrador/medico', medico.fk_medico]">{{medico.medico}}</a> </td>            
                <td>{{medico.total_puntos}}</td> 
                <td>{{medico.total_redimir}}</td>
                <td>{{medico.saldo}}</td>       
            </tr>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="currentPage.first" [rows]="currentPage.rows" [totalRecords]="totalItems" ></p-paginator>
    </div>
</section>
